import "./dropdown-with-checkbox.component.scss";

import { useEffect, useMemo, useState, memo } from "react";
import { useTranslation } from 'react-i18next';

import Checkbox from "../Checkbox";

const DisplayButton = props => {
  const { t } = useTranslation();
  const {
    label,
    isToggleAll,
    selectedCount
  } = props;

  let displayButton = null;

  if(isToggleAll){
    // All.
    displayButton = <span>{t('b1c94ca2fb')}</span>;
  }
  else if(label){
    // Customize label.
    displayButton = <span>{t(label, {'count': selectedCount})}</span>
  }
  else if(label){
    // Customize label.
    displayButton = <span>{t(label, {'count': selectedCount})}</span>
  }else{
    if(selectedCount){
      // xxxx selected.
      displayButton = <span>{selectedCount + ' ' + t('3c9e0c6510')}</span>
    }else{
      // Please Select.
      displayButton = <span>{t('3569a4e76b')}</span>
    }
  }

  return displayButton;
}

const DisplayDiviceButton = props => {
  const { t } = useTranslation();
  const {
    label,
    isDeviceToggleAll,
    selectedDeviceCount
  } = props;

  let displayButton = null;

  if(isDeviceToggleAll){
    // All.
    displayButton = <span>{t('b1c94ca2fb')}</span>;
  }
  else if(label){
    // Customize label.
    displayButton = <span>{t(label, {'count': selectedDeviceCount})}</span>
  }
  else if(label){
    // Customize label.
    displayButton = <span>{t(label, {'count': selectedDeviceCount})}</span>
  }else{
    if(selectedDeviceCount){
      // xxxx selected.
      displayButton = <span>{selectedDeviceCount + ' ' + t('3c9e0c6510')}</span>
    }else{
      // Please Select.
      displayButton = <span>{t('3569a4e76b')}</span>
    }
  }

  return displayButton;
}

const NormalDropdownWithCheckbox = (props) => {
  const { id, disabled, label, isToggleAll, selectedCount , extendClassName, extendLiClassName, allMode ,onChangeAll, itemList, onChange} = props;
  const { t } = useTranslation();

  return (
    <div className='dropdown'>
      <button
        className={`btn btn-dropdown dropdown-toggle ${extendClassName || ''}`}
        type="button"
        id={id}
        data-bs-toggle="dropdown"
        data-bs-display="static"
        data-bs-auto-close='outside'
        disabled={disabled}
        aria-expanded="false"
      >

        <DisplayButton
          label={label}
          isToggleAll={isToggleAll}
          selectedCount={selectedCount}
        />

      </button>
      <ul className="dropdown-menu" aria-labelledby={id}>
        {
          allMode &&
          <li className='li-border-bottom'>
            <Checkbox
              id={id + '-all'}
              label={t('b1c94ca2fb')} // All
              checked={isToggleAll}
              onChange={() => !!onChangeAll && onChangeAll(!isToggleAll)}
            />
          </li>
        }
        {itemList.map((item, index) => {
          return (
            <li
              className={`${item.isActive ? 'active' : ''} ${item.isAll ? 'li-border-bottom' : ''} ${extendLiClassName || ''}`}
              key={item.title + '-' + index}
            >
              {item.suffix ? (
                <Checkbox
                  id={id ? id + '-title-' + index : item.title + '-' + index}
                  label={t(item.title) + ' (' + t(item.suffix) + ')'}
                  checked={item.checked}
                  onChange={() => !!onChange && onChange(item)}
                />
              ) : (
                <Checkbox
                  id={id ? id + '-title-' + index : item.title + '-' + index}
                  label={t(item.title)}
                  checked={item.checked}
                  onChange={() => !!onChange && onChange(item)}
                />
              )}
            </li>
          );
        })}
      </ul>
  </div>
  );
}

const ThreeDropdownWithCheckbox = (props) => {
  const { id, disabled, label, isDeviceToggleAll, selectedDeviceCount , extendClassName, allMode ,onChangeAll, itemList, onChange, onChangeLevel1} = props;
  const { t } = useTranslation();

  return (
    <div className='dropdown'>
      <button
        className={`btn btn-dropdown dropdown-toggle ${extendClassName || ''}`}
        type="button"
        id={id}
        data-bs-toggle="dropdown"
        data-bs-display="static"
        data-bs-auto-close='outside'
        disabled={disabled}
        aria-expanded="false"
      >

        <DisplayDiviceButton
          label={label}
          isDeviceToggleAll={isDeviceToggleAll}
          selectedDeviceCount={selectedDeviceCount}
        />

      </button>
      <ul className="dropdown-menu" aria-labelledby={id}>
        {
          allMode &&
          <li className='li-border-bottom' style={{padding: '0px'}}>
            <Checkbox
              id={id + '-all'}
              label={t('b1c94ca2fb')} // All
              checked={isDeviceToggleAll}
              onChange={() => !!onChangeAll && onChangeAll(!isDeviceToggleAll)}
            />
          </li>
        }
        {itemList.map((item, index, key) => {
          return (
            <li
              className={`${item.isActive ? 'active' : ''} ${item.isAll ? 'li-border-bottom' : ''}`}
              key={item.name + '-' + index}
            >
              <div className='checkbox-sub-input' style={{marginLeft: '20px'}}>
                <input
                  id={id ? id + '-' + item.name + '-' + index : item.name + '-' + index}
                  type='checkbox'
                  onChange={e => !!onChangeLevel1 && onChangeLevel1(item, e.target.checked)}
                  label={t(item.title)}
                  checked={item.checked}
                  data-bs-auto-close='outside'
                />
                <label
                  htmlFor={id ? id + '-' + item.name + '-' + index : item.name + '-' + index}
                  className='text'
                >
                  {t(item.title)}
                </label>
                {item.list.map((items, index , key) => {
                  return (
                    <div className='checkbox-sub-input' style={{marginLeft: '20px'}} key={items.deviceName + '-' + index}>
                      <input
                        id={id ? id + '-' + items.deviceName + '-' + index : items.deviceName+ '-' + index}
                        type='checkbox'
                        onChange={e => !!onChangeLevel1 && onChangeLevel1(items, e.target.checked)}
                        checked={items.checked}
                      />
                      <label
                        htmlFor={id ? id + '-' + items.deviceName + '-' + index : items.deviceName + '-' + index}
                        className={'text'}
                      >
                        {items.title}
                      </label>
                    </div>
                );
              })}
              </div>
            </li>
          );
        })}
      </ul>
  </div>
  );
}

const DropdownWithCheckbox = props => {
  const {
    id,
    dropdownType, // 單層 或 三層
    allMode, // 打開All checkbox
    label,
    extendClassName,
    extendLiClassName,
    itemList,
    disabled,
    onChangeAll,
    onChange,
    onChangeLevel1,
    selectedDeviceCount,
    isDeviceToggleAll

  } = props;

  let checkboxType = dropdownType || 'normal';
  const { t } = useTranslation();
  const [isToggleAll, setIsToggleAll] = useState(false);

  const selectedCount = useMemo(() => itemList.filter(item => !item.isAll && item.checked).length, [itemList]);
  useEffect(() => allMode && setIsToggleAll(selectedCount === itemList.length), [selectedCount]);


  return (
    <div className='dropdown-with-checkbox-container'>
      {checkboxType === 'normal' &&
        <NormalDropdownWithCheckbox
          id = {id}
          allMode = {allMode}
          label = {label}
          extendClassName = {extendClassName}
          extendLiClassName={extendLiClassName}
          itemList = {itemList}
          disabled = {disabled}
          onChangeAll = {onChangeAll}
          onChange = {onChange}
          isToggleAll = {isToggleAll}
          selectedCount= {selectedCount}
        />
      }
      {checkboxType === 'three' &&
        <ThreeDropdownWithCheckbox
          id = {id}
          allMode = {allMode}
          label = {label}
          extendClassName = {extendClassName}
          itemList = {itemList}
          disabled = {disabled}
          onChangeAll = {onChangeAll}
          onChange = {onChange}
          onChangeLevel1 = {onChangeLevel1}
          selectedDeviceCount = {selectedDeviceCount}
          isDeviceToggleAll = {isDeviceToggleAll}
        />
      }
    </div>
  );
};

export default memo(DropdownWithCheckbox);
